import { ProfileButton } from "@/components/ProfileButton/ProfileButton";
import { Group } from "@mantine/core";
import { ExportButton } from "./ExportButton";
import { SaveStatus } from "./SaveStatus";
import { Sharing } from "./Sharing";

export const RightNav = () => {
  return (
    <Group ml={"auto"} gap={"xs"} mr={"xs"}>
      <SaveStatus />
      <ExportButton />
      <Sharing />
      <ProfileButton />
    </Group>
  );
};
